import { CommonModule, formatDate } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbOffcanvas, NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AcademicYearService } from '../../../../../core/services/academic-year.service';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { FileService } from '../../../../../core/services/file.service';
import { StudentAyClassroomService } from '../../../../../core/services/student-ay-classroom.service';
import { TemplateSacService } from '../../../../../core/services/template-sac.service';
import { TemplateService } from '../../../../../core/services/template.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-inscription-renew',
    templateUrl: './inscription-renew.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule],
    styleUrls: ['./inscription-renew.component.css']
})
export class InscriptionRenewComponent {
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  pdfViewLoader=false
  buttonsPermission :any|undefined;
  search_text=""
   structures:any[] =[]
   roles:any[] =[]
   periods:any[] =[]
   data:any[] =[]
   concerned:any[] =[]
   students:any[] =[]
   ays:any[] =[]
   classrooms:any[] =[]
   templates:any[] =[]
   selected_data:any;
   text:any;
   modalOption:any; 
   ayId:any;
   classroomId:any;
   isDtInitialized:boolean = false
   is_active=null
   loading=false
   tag="admin-inscription-renew"
   pg={
     pageSize:10,
     p:0,
     total:0
   }
   role:any
   user:any
   type:any
 
 
   constructor(
    private spinnerService:NgxSpinnerService,
    private router:Router,
     private ayService:AcademicYearService,
     private fileService:FileService,
     private templateService:TemplateService,
     private templateSacService:TemplateSacService,
     private classroomService:ClassroomService,
     private sacService:StudentAyClassroomService,
     private toastrService:ToastrService,
     private offcanvasService: NgbOffcanvas,
       config: NgbModalConfig,
       private lsService:LocalStorageService,
     private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      }
 
 
   ngOnInit(): void {
     
     this.user=this.lsService.get(GlobalName.userName)
       this.role=this.user.roles[0].name.toLowerCase()
       console.log(this.role)
     this.init()
     this.getActions()
   }
 
   init(){
     this.getAll()
     this.getClassrooms()
     this.getAys()
   }
 

   loadData1(event:any){
    this.ayId=event
    this.getAll()
   }

   loadData2(event:any){
    this.classroomId=event
    this.getAll()
   }
  
   loadContent(event:any){
    let text=this.templates.find((el:any)=>el.id==event).text
    let newstr = text.replace('[NOM_PRENOM_ELEVE]',`${this.selected_data?.student?.lastname} ${this.selected_data?.student?.firstname}`)
        newstr = newstr.replace('[DATE_NAISSANCE_ELEVE]',`${formatDate(this.selected_data?.student?.birthdate,'dd-MM-yyyy','fr_FR')}`)
        newstr = newstr.replace('[CLASSE_ELEVE]',`${this.selected_data?.classroom?.name}`)
        newstr = newstr.replace('[ANNEE_ACADEMIQUE_ELEVE]',`${this.selected_data?.ay?.name}`)
        newstr = newstr.replace('[DATE]',formatDate(new Date(),'dd-MM-yyyy','fr_FR'))

        this.text=newstr
      console.log(`${this.selected_data?.student?.lastname} ${this.selected_data?.student?.firstname}`,newstr)
   }
 
   getAll(){
    if(this.classroomId!=undefined){
      this.sacService.getAll(this.classroomId, this.ayId).subscribe((res:any)=>{
        this.data=res.data
        this.pg.p=0
        this.pg.total=res.data.length
        this.modalService.dismissAll()
      },
      (err:any)=>{
        AppErrorShow.showError("Gestion des réinscriptions",err)

      })
    }
    
   }

 
   getClassrooms(){
     this.classroomService.getAll().subscribe((res:any)=>{
       this.classrooms=res.data
     },
     (err:any)=>{
      AppErrorShow.showError("Gestion des réinscriptions",err)

     })
   }
 
   getAys(){
    this.ayService.getAll().subscribe((res:any)=>{
      this.ays=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des réinscriptions",err)
    })
  }

   store(value:any){
     this.loading=true
     
     this.templateSacService.store({
      sac_id:this.selected_data?.id,
      template_id:value?.template_id,
      content:value.text
     }).subscribe((res:any)=>{
         this.loading=false
         this.toastrService.success(res.message)
         this.getAll()
 
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des réinscriptions",err)

     })
   }
   update(value:any){
     this.loading=true
     delete value.type
     this.templateService.update(this.selected_data.id,value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des réinscriptions",err)

     })
   }
   delete(id:any){
   //  if(!this.verifyIfElementChecked()) return ;
     let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
     confirmed.then((result:any)=>{
        if (result.isConfirmed) {
     this.templateSacService.delete(id).subscribe((res:any)=>{
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       console.log(err)
         AppErrorShow.showError("Gestion des réinscriptions",err)

     })
   }
 })
   }
   checked(el?:any){
     this.selected_data=el;
     this.is_active=el.status
   }

   verifyIfElementChecked(){
     console.log(this.selected_data)
     if (this.selected_data==null) {
       this.toastrService.warning("Aucun élément selectionné");
       return false;
     }
     return true;
   }
 
 
 
   dismiss(){
     this.modalService.dismissAll()
   }
 
   add(content:any){
    if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
   }
 
 
   show(){
     if(!this.verifyIfElementChecked()) return ;
     this.router.navigate(['/admin/inscription-renew-details/'+this.selected_data.student?.code])
    //  this.modalOption={centered:false,size:"lg"}
    //  this.modalService.open(content,{size:'lg'});
   }
 
   edit(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
 
   }
 
   setStatus(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.templateService.setState(this.selected_data.id,value).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getAll()
       },
       (err:any)=>{
         console.log(err)
           AppErrorShow.showError("Gestion des réinscriptions",err)

       })
   }
   reject(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.templateService.setState(this.selected_data.id,0).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getAll()
       },
       (err:any)=>{
         console.log(err)
           AppErrorShow.showError("Gestion des réinscriptions",err)

       })
   }
 
   getPage(event:any){
     this.pg.p=event
   }
 
   getActions(){
     // this.buttonsPermission = {
     //   show:AppActionCheck.check(this.tag,'Consultation'),
     //   add:AppActionCheck.check(this.tag,'ajout'),
     //   edit:AppActionCheck.check(this.tag,'edition'),
     //   delete:AppActionCheck.check(this.tag,'suppression'),
     //   status:AppActionCheck.check(this.tag,'statut')
     // };
     this.buttonsPermission={
       show:true,
       add:true,
       edit:true,
       delete:true,
       status:true,
     }
   }

   getFile(path:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get2({path:path,disk:'public'}).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des réinscriptions",err)

    })
  }
}
